import { Model } from '@vuex-orm/core';
import STORE from '@/store/STORE';

const { name } = STORE.modules.suggestUsers;

export default class SuggestUsers extends Model {
  static entity = `${ name }`;

  static fields() {
    return {
      id: this.increment(1),
      username: this.string(''),
      first_name: this.string(''),
      last_name: this.string(''),
      fullname: this.string(''),
    };
  }

  static methodConf = {
    http: {
      url: '/catalog/suggest_users',
    },
  };
}
